import { type ISanitizeOptions } from "@frontiers-vue3/public-pages";

export function useSanitizeHtml(
  dirtyHtml: string,
  options: ISanitizeOptions = {}
): string {
  const { $sanitizeHtml } = useNuxtApp();

  const trustedHtml = (
    $sanitizeHtml as (input: string, options: ISanitizeOptions) => string
  )(dirtyHtml, options);

  return trustedHtml;
}
